/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, } from 'athenaeum';

const getDimensions = ({ icon }) => {
  let height = '1.125rem';
  let width = height;

  if (icon === 'close') {
    height = '1rem';
    width = height;
  }

  return {
    width,
    height,
  };
};

const IconWrapper = props => (
  <div
    onClick={props.onClick}
    className={props.className}
  >
    <Icon
      icon={props.icon}
      {...getDimensions(props)}
    />
  </div>
);

IconWrapper.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default IconWrapper;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Search/IconWrapper/index.js